import { NO_ERROR_STACK_PRESENT_MESSAGE } from '@datadog/browser-core/cjs/domain/error/error';
import type { LogsEvent } from '@datadog/browser-logs';

const errorIgnoreListPartial = [
  'pinterest',
  'gtag',
  'doubleclick',
  'tealium',
  'web.aips-sol',
  'web.sol-data',
  'asia.creativecdn',
  'google-analytics',
  'hotjar',
  'snapchat',
  'googlesyndication',
  'message":"Failed to fetch',
];

const errorIgnoreListExact = [
  'console error:',
  '',
  'Error: Failed to fetch',
  'Failed to fetch',
  'Network Error',
  "console error: Error: Timeout when executing 'fetch'",
  'NetworkError when attempting to fetch resource.',
];

export const beforeSend = (log: LogsEvent) => {
  if (log?.error?.stack) {
    const containsChromeNoStackMessage =
      log.error.stack === NO_ERROR_STACK_PRESENT_MESSAGE;
    const containsHost = log.error.stack.includes(window.location.host);

    if (!containsChromeNoStackMessage && !containsHost) {
      return false;
    }
  }

  for (const partialError of errorIgnoreListPartial) {
    if (log.message.toLowerCase().includes(partialError)) {
      return false;
    }
  }

  for (const exactError of errorIgnoreListExact) {
    if (log.message.trim() === exactError.trim()) {
      return false;
    }
  }

  return true;
};
